
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientInfosResource,
  ClientRepatriationOpportunityOnboardingResource,
  PhoneRequest,
  ValidationError,
} from '../models';
import {
    ClientInfosResourceFromJSON,
    ClientInfosResourceToJSON,
    ClientRepatriationOpportunityOnboardingResourceFromJSON,
    ClientRepatriationOpportunityOnboardingResourceToJSON,
    PhoneRequestFromJSON,
    PhoneRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface ChangePhoneNumberRequest {
    phoneRequest: PhoneRequest;
}

/**
 * 
 */
export class ClientInfosApi extends runtime.BaseAPI {

    /**
          */
    async changePhoneNumberRaw(requestParameters: ChangePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['phoneRequest'] == null) {
            throw new runtime.RequiredError(
                'phoneRequest',
                'Required parameter "phoneRequest" was null or undefined when calling changePhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/repatriation-opportunity/api/client-informations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PhoneRequestToJSON(requestParameters['phoneRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async changePhoneNumber(requestParameters: ChangePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.changePhoneNumberRaw(requestParameters, initOverrides);
    }

    /**
     * Get client infos
          */
    async getClientInfosRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientInfosResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientInfosResource>({
            path: `/repatriation-opportunity/api/client-informations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientInfosResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get client infos
          */
    async getClientInfos(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientInfosResource> {
        const response = await this.getClientInfosRaw(initOverrides);
        return response._data;
    }

    /**
     * Get client onboarding situation
          */
    async getClientOnboardingSituationRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientRepatriationOpportunityOnboardingResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientRepatriationOpportunityOnboardingResource>({
            path: `/repatriation-opportunity/api/onboarding-situation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientRepatriationOpportunityOnboardingResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get client onboarding situation
          */
    async getClientOnboardingSituation(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientRepatriationOpportunityOnboardingResource> {
        const response = await this.getClientOnboardingSituationRaw(initOverrides);
        return response._data;
    }

}
